import React from 'react'
import { Box } from '@chakra-ui/react';
import { FaChevronRight, FaHeart } from 'react-icons/fa'
import map from 'lodash/map'
import size from 'lodash/size'
import loadable from '@loadable/component';

// import BackgroundImage from '../../../BackgroundImage';
import Button from '../../../components/Button';
import RatioImage from '../../RatioImage'
import HtmlWrapper from './HtmlWrapper';
import makeLink from '../../../helpers/makeLink';
import useImpression from '../../../hooks/useImpression'
import useTracker from '../../../hooks/useTracker'
import parseHtml from '../../../helpers/parseHtml';
import LinkStats from '../../../adminComponents/ProfileEditor/LinkStats';

const Carousel = loadable(() => import('../../../components/Carousel'))

const LinkLabel = ({
  url,
  children,
  isEditing,
  isPreview,
  mode,
  onClick,
}) => {
  return (
    <Button
      justifyContent="space-between"
      href={!isEditing && (mode === 'internal' ? url : makeLink(url))}
      isExternal={isPreview || mode !== 'internal'}
      variant="ghost"
      rightIcon={<FaChevronRight />}
      isFullWidth
      rounded={0}
      px="6"
      py="1em"
      height="auto"
      colorScheme="primary"
      onClick={onClick}
    >
      {children}
    </Button>
  )
}

const CollectionItem = ({
  id: blockId,
  item,
  links,
  isPreview,
  isEditing,
  isList,
  profileId,
  impressions,
  clicks,
}) => {
  const linkData = item?.cta && ((isPreview && item['linkId-editor']) || links[item.linkId])
  const ref = useImpression(profileId, blockId, item.itemId, item.linkId)
  const clickTrack = useTracker('click')
  const child = (
    <Box bg="white" pb="4" rounded="md" overflow="hidden" ref={!isEditing && !isPreview ? ref : undefined}>
      <RatioImage
        src={item.image}
        layout="fill"
        objectFit="cover"
        alt={item.title}
        isPreview={isPreview}
        isEditing={isEditing}
        ratio={1}
      />
      {isList && <Box height="8" />}
      {linkData && (
        <LinkLabel
          isEditing={isEditing}
          {...linkData}
          onClick={() => !isEditing && !isPreview && clickTrack(profileId, blockId, item.itemId, item.linkId)}
        >{item.text}</LinkLabel>
      )}
      <Box px="6" py="2">
        {item.description && (
          <HtmlWrapper>
            {parseHtml(item.description)}
          </HtmlWrapper>
        )}
      </Box>
    </Box>
  )
  return isEditing ? (
    <LinkStats
      linkId={item.linkId}
      blockId={blockId}
      profileId={profileId}
      itemId={item.itemId ?? item.id}
      impressions={impressions}
      clicks={clicks}
      collectionName="collections"
    >
      {child}
    </LinkStats>
  ) : child
}

const Collection = ({
  items,
  isEditing,
  isPreview,
  links,
  profileId,
  impressions,
  clicks,
  id = '',
}) => {
  const [collectionId] = id.split('.')
  // const linkData = (isPreview && props['linkId-editor']) || links[linkId]
  const isList = size(items) > 1
  const children = map(items, (item, i) => (
    <CollectionItem
      key={i}
      item={item}
      isEditing={isEditing}
      isPreview={isPreview}
      links={links}
      isList={isList}
      id={collectionId}
      profileId={profileId}
      impressions={impressions}
      clicks={clicks}
    />
  ))
  return (
    <Box w={`full`} py="2" as="section">
      {isList ? (
        <Carousel ratio={1} dotInside>
          {children}
        </Carousel>
      ) : children}
    </Box>
  )
}

export default Collection
